import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function queryTrajectoryApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.trackapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/track/query"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/track/query"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/track/query"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/track/query"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCode Desc480"
            },
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc481"
            },
            {
              name: "trackingNoList",
              type: "ARRAY",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.trackingNoListDesc482"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "",
              normal: "Y",
              describe: "apiDocDesc.successDesc483"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "",
              normal: "Y",
              describe: "apiDocDesc.reasonDesc484"
            },
            {
              name: "total",
              type: "VARCHAR",
              require: "",
              normal: "Y",
              describe: "apiDocDesc.totalDesc485"
            },
            {
              name: "data",
              type: "ARRAY",
              require: "",
              normal: "Y",
              describe: "apiDocDesc.dataDesc486",
              children: [
                {
                  name: "trackingNo",
                  type: "VARCHAR",
                  require: "",
                  normal: "Y",
                  describe: "apiDocDesc.trackingNoDesc487"
                },
                {
                  name: "traces",
                  type: "ARRAY",
                  require: "",
                  normal: "Y",
                  describe: "apiDocDesc.tracesDesc488",
                  children: [
                    {
                      name: "status",
                      type: "STRING",
                      require: "",
                      normal: "Y",
                      describe: "apiDocDesc.statusDesc489"
                    },
                    {
                      name: "scanType",
                      type: "STRING",
                      require: "",
                      normal: "Y",
                      describe: "apiDocDesc.scanTypeDesc490"
                    },
                    {
                      name: "scanTime",
                      type: "STRING",
                      require: "",
                      normal: "Y",
                      describe: "apiDocDesc.scanTimeDesc491"
                    },
                    {
                      name: "desc",
                      type: "STRING",
                      require: "",
                      normal: "Y",
                      describe: "apiDocDesc.descDesc492"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        customerid: "DIANXIAOMI-TEST",
        warehouseCode: "SH.001",
        trackingNoList: [
          "JT3112984607497",
          "JTE000649114465",
          "JTE000653337708"
        ]
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "1a0c384917555931356696354ee7a2",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            data: [
              {
                trackingNo: "JT3112984607497",
                traces: [
                  {
                    scanTime: "2025-03-19 13:56:13",
                    desc: "【测试网点02testt】的李宁测试网点（18862988115）已取件，投诉电话：95040668501",
                    scanType: "快件揽收",
                    status: "已揽收"
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  };
}
